import {useAuth0} from '@auth0/auth0-react';
import {useMutation, useQueryClient} from 'react-query';
import {API_URL} from 'Store/Shared/Middleware/API/Constants';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import {useDispatch} from 'react-redux';
import {NOTIFICATIONTYPE} from 'Store/Notification/ActionTypes';

export const useEntityRecord = (entity: string) => {
    const queryKey = `/api/v2/${EntityHelper.getEndpoint(entity)}/`;
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    
    const { getAccessTokenSilently } = useAuth0();

    const deleteEntityRecord = async (queryEndpoint) => {
        const accessToken = await getAccessTokenSilently();

        const rawResponse = await fetch(`${API_URL}${queryEndpoint}`, {
            method: 'DELETE',
            headers: {
                'Authorization': `Bearer ${accessToken}`
            }
        });

        if (!rawResponse.ok) {
            throw new Error('Network response was not ok');
        }

        return rawResponse.status === 204;
    }

    const {
        isLoading: isDeleting,
        isSuccess: isDeleted,
        ...rawMutation
    } = useMutation(deleteEntityRecord);

    const deleteRecordById = async (recordId: string) => {
        try {
            await rawMutation.mutateAsync(queryKey + recordId);

            dispatch({
                payload: {
                    message: 'Succesvol verwijderd'
                },
                type: NOTIFICATIONTYPE.SUCCESS
            });
        } catch (error) {
            dispatch({
                payload: {
                    message: 'Verwijderen mislukt'
                },
                type: NOTIFICATIONTYPE.ERROR
            });
        }
    }

    return {
        isDeleting,
        isDeleted,

        deleteRecordById
    }
}